import Image from "next/image"
import { CONTAINER_STYLES } from "../styles/basic"
export const Footer = () => {
    return (
        <footer className="py-8">
            <div className={`${CONTAINER_STYLES} text-center`}>
                <div className="mb-4 flex items-center justify-center gap-3">
                    <div className="flex h-6 w-6 items-center justify-center">
                        <Image
                            src="/logo/logo-black.svg"
                            alt="NPX Logo"
                            width={24}
                            height={24}
                            className="dark:hidden"
                        />
                        <Image
                            src="/logo/logo-white.svg"
                            alt="NPX Logo"
                            width={24}
                            height={24}
                            className="hidden dark:block"
                        />
                    </div>
                    <span className="font-heading font-bold text-gray-900 dark:text-white">Workforce</span>
                </div>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                    © {new Date().getFullYear()} NPX. Transforming nuclear energy through AI innovation.
                </p>
            </div>
        </footer>
    )
}
